import { Field } from 'formik'
import { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import styles from './index.module.scss'

type Props = {
  country: string
}

export const CountrySelectField: FC<Props> = observer(({ country }) => {
  const { viewer, companies } = useStores()

  const fetchCountries = async () => {
    await companies.fetchCountries()
  }

  useEffect(() => {
    if (!viewer.isInitialized) {
      return
    }

    if (companies?.countries.length === 0) {
      fetchCountries()
    }
  }, [viewer.isInitialized])

  return (
    <div className={styles.container}>
      <Field as='select' name='country'>
        <option value='Please select'>Please select</option>
        {companies.countries.map((option) => {
          return (
            <option key={option.id} value={option.name}>
              {option.name}
            </option>
          )
        })}
      </Field>
      <input name='country' type='hidden' value={country} />
    </div>
  )
})
